// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'fdcb1f2c0f615342c91184763332fcd1e73a7dfd';
export const BUILD_NUMBER = '295';
export const BUILD_TIMESTAMP = '2026-11-04T04:45:11.408Z';
